// extracted by mini-css-extract-plugin
module.exports = {"top":"testPrints_top__2XEMu","ruler":"testPrints_ruler__I5xer"};